/**
 * CeStore Menu Navigation 
 * 
 * Version 1.0.6
 * 
 */
jQuery(document).ready(function($){
   var adjust = {
        initialize: function() {
            this.stickyNavOnScroll();
            this.onResize();
            this.onClick();
            this.scrollTopBtn();
			this.bookmark();
            this.modalVideoDialog();
            
            $('#mobile-primary-navbar-dropdown, #ce-search-box').on('show.bs.collapse', function(e){ 
                $('body').addClass('show-popup');
            });
            $('#mobile-primary-navbar-dropdown, #ce-search-box').on('hidden.bs.collapse', function(e){ 
                $('body').removeClass('show-popup');
            });
            
        },
        stickyNavOnScroll : function(){
            // sticky nav on scroll
            var el_stick = $(".main-navbar-wrap");
            var pos = el_stick.position();					   
            
            /*
            $(window).on('scroll',function() {
                var windowpos = $(window).scrollTop();
                if (windowpos - 100 > pos.top + el_stick.height() ) {
                    el_stick.addClass("stick");
                    $('body').addClass("stick");
                } else {
                    el_stick.removeClass("stick");	
                    $('body').removeClass("stick");
                }
            });
            */
           
           
            var el_navbar = $(".main-navbar-wrap");
            $(window).on('scroll',function() {
                var windowpos = $(window).scrollTop();
                if (windowpos > 100) {
                    el_navbar.addClass("minimize");
                } else {
                    el_navbar.removeClass("minimize");	
                }
            });
        },
        onResize : function(){
            $( window ).resize(function(e) { 
                $('#mobile-primary-navbar-dropdown').collapse('hide'); //close mobile popup
            });
        },
        onClick : function() {
            $('body').click(function(event) {   
                 //e.stopPropagation()   
                 //e.preventDefault()

                $target = $(event.target);

                if ($('#ce-search-box').is(':visible')) {
                    if (!$target.closest('#ce-search-box').length ) {
                        $('#ce-search-box').collapse('hide');   
                    }
                    
                    return true;
                }

                if ($('#mobile-primary-navbar-dropdown').is(':visible')) {
                    // popup menu sichtbar und klick event außerhalb 
                    if ((!$target.closest('#mobile-primary-navbar-dropdown.show').length) || ("mobile-menu-closer" === event.target.id)){
                        $('#mobile-primary-navbar-dropdown').collapse('hide');  //close mobile popup
                    }
                    
                    return true;
                }
            });    
        },
        scrollTopBtn : function(){
            var btn = $('#btn-scroll-top');

            $(window).scroll(function() {
              if ($(window).scrollTop() > 500) {
                    btn.addClass('show');
              } else {
                    btn.removeClass('show');
              }
            });

            btn.on('click', function(e) {
              e.preventDefault();
              $('html, body').animate({scrollTop:0}, '600');
            });
        },

        /* 
        * Smooth scrolling to bookmark on same and other page
        * <a class="bookmark" href="#book-01" data-offset="250">goto #book with offset 200</a>
        * <a class="bookmark more-link" href="example.com/my-page/#book-01&250">goto #book with offset 200</a>
        * 
        */
		bookmark: function() {            
            var $root = $('html, body');

            function goToAncor( hash, offset ) {
                // is the anchor on the same page?
                var $element = $(document).find(hash); 
                var intOffset = /^-?[0-9]+$/.test(offset);

                if ( $element ) {
                    $root.animate({
                        scrollTop: $element.offset().top +  ( intOffset ? -offset : 0 )
                    }, 1000
                    );
                }
            }
            $( 'a.bookmark' ).on( 'click', function( event ) {
               var hash = this.hash; //this.hash reads the href attribute of this, and gets the part of the URL beginning with #
               var offset = $(this).data( "offset" );

                // ancor on the same page
                if ( hash && this.href.slice( 0, -hash.length-1 ) == location.href.slice( 0, -location.hash.length-1 ) ) {
                    goToAncor( hash, offset );

                    return false;
                }
            });

            // on page loading get bookmark part of the URL with # 
            var hash = $( location).attr( 'hash' );

            if ( hash ) {
                var offset = 0;
                // hash has offset e.g.: example.com/my-page#bookmark&250
                if ( hash.indexOf( '&' ) > -1 ) {
                    offset =  hash.slice( hash.indexOf( '&' ), hash.lenght );
                    
                    if ( offset ) {
                        offset = offset.slice(1);
                        hash = hash.slice( 0,  hash.indexOf("&") );
                    }
                }

                goToAncor( hash, offset );
            }
        },

        modalVideoDialog :function(){
            // Remove video source on dialog close
            $('.modal.ce-modal-dlg.video').on('show.bs.modal', function (event) {
                var iframe =$(this).find('iframe');
                $(iframe).attr("src", $(iframe).data('src') );
            });

            $('.modal').on('hidden.bs.modal', function (e) {
                $(this).find('iframe').attr("src", "");
            });
        }
   };   
   
   adjust.initialize();

});


